<template>
    <div class="row whole">
        <div v-for="(b,index) in boxes" class="col-4 col-md-2 outerbox d-md-flex">

            <router-link :to='shortLink(b.zusatz.link)' tag="div" class="box  "
                         :style="{backgroundImage:getBackground(b.bild.url)}" @mouseover.native="hover(index,1)"
                         @mouseout.native="hover(index,0)" :class="{'hover':b.hovered}" :key="index"
                         v-squared>

                <div class="blue" v-squared>
                    <div class="upperbox">

                        <div class="icon">

                            <img :src="b.icon.url" alt="">
                        </div>
                        <hr/>
                        <div class="name">
                            {{ b.name}}

                            <!--<span class="d-inline d-md-none">{{ b.zusatz.button}}</span>-->
                            <!--<span class="d-none d-md-inline">{{ b.name}}</span>-->
                        </div>
                    </div>
                    <hr class="hovered">
                    <transition name="wait">
                        <div class="added " v-if="b.hovered">
                            <div class="text">
                                {{b.zusatz.text}}
                            </div>
                            <router-link :to='shortLink(b.zusatz.link)' class="button white" v-if="b.zusatz.link">
                                {{b.zusatz.button}}
                            </router-link>
                        </div>
                    </transition>
                </div>
            </router-link>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'Blockmenu',
        data() {
            return {}
        },
        props: ['boxes'],

        created: function () {

        },
        methods: {
            hover(index, x) {
                this.$set(this.boxes[index], 'hovered', x)
            }
        },
        computed: {
            indexedBoxes() {
                this.boxes.forEach(function (b, index) {
                    this.$set(this.boxes[index], 'hovered', 0)
                    // b.hovered= 0
                }.bind(this))
                return this.boxes;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>

    .wait-enter-active {

        transition: all .5s ease 0.5s;
    }

    .wait-enter {
        transition: all .5s ease 0.5s;
        opacity: 0;
    }

    .wait-leave-active, .wait-leave-to, .wait-leave {
        opacity: 0 !important;
        transition: none !important;
    }

    .added {

    }

    .outerbox, .outerbox.first {
        .box.hover {
            transition: all 0.5s ease;
            display: block;
            transform: scale(1.2);

            .blue {
                cursor: pointer;

                .upperbox {
                    justify-content: center;
                    flex: 0 0 40%;

                    hr {
                        display: none;
                    }

                    .icon {
                        flex: 0 0 30%;
                        padding: 5% 0 0;

                        img {
                            height: 100%;
                        }
                    }

                    .name {
                        align-items: center;
                    }
                }

                width: 100%;
                margin: 0 auto;
                position: relative;
                height: 150% !important;
                transform: translateY(0);

                .added {
                    padding: 0 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    flex: 0 0 50%;
                    flex-grow: 1;
                    max-width: 100%;
                    font-size: 12px;
                    line-height: 18px;
                        .button {
                            margin-top: 10px;
                        }

                    .text {

                        @include tablet {
                    line-height: 14px;
                            display: none !important;
                        }
                    }
                    @include laptop {
                        .text {
                            font-size: 11px;
                            line-height: 14px;
                        }
                        .button {
                            padding: 10px 15px;
                        }
                        padding: 0 20px;
                    }

                    div {

                    }

                }

                hr.hovered {
                    display: block;
                    margin: 0;
                }
            }
        }
    }

    .box {
        background-repeat: no-repeat;
        background-position: top;
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        margin-bottom: 60%;
        cursor: pointer;

        hr.hovered {
            display: none;
        }

        color: #fff;

        .blue {
            .upperbox {
                display: flex;
                flex: 0 0 50%;
                height: 50%;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                width: 100%;
            }

            transition: all 0.5s ease;

            .added {
                max-width: 100%;
                transition: all .5s ease 0.5s;
            }

            transform: translateY(80%);
            width: 80%;
            align-items: center;
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-around;
            background: linear-gradient(360deg, rgba($blue, 0.5) 1.46%, rgba($blue, 0.5) 45.02%, rgba($blue, 0.5) 90.2%), rgba($blue, 0.9);

            .icon {
                flex: 0 0 30%;
                width: 100%;
                height: 20%;
                /*min-height: 30px;*/
                img {
                    height: 100%;
                }
            }

            .name {
                font-family: $headfont;
                display: flex;
                flex: 0 0 15%;
                line-height: 25px;
                margin-top: 10px;
                font-size: 20px;
                color: #fff;
                letter-spacing: 0.05em;

            }
        }

        hr {
            border-top: 1px solid #fff;
            width: 50%;
        }

        @include mobile {
            background: none !important;
            margin-bottom: 30px;
            .blue {
                width: 100%;
                transform: translateY(0);
                background: $blue;

                .name {
                    font-size: 18px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Blockmenu.vue